// extracted by mini-css-extract-plugin
export default {"row":"Details_row__e7AOe","column":"Details_column__r-zqf","title":"Details_title__4TFfH","date":"Details_date__LUb6V","highlight":"Details_highlight__nllL-"};